import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import colors from '../../../configuration/colors'
import H5 from '../../typography/headers/H5'
import { getViewResourceIcon } from '../../../utils/resources'
import MarkdownLabel from '../../mini/MarkdownLabel'

const ResourceContainerCard = styled.div`
  background: none;
  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  height: auto;
  background: ${colors.white};
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
`

const ResourceImage = styled.img`
  height: 85px;
  width: 100%;
  margin-bottom: 10px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  background-image: ${props =>
    `linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${props.image}) !important`};
  background-size: 100%;
}

`

const ImagePlaceholder = styled.div`
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    center top / 100% no-repeat rgb(255, 255, 255);
  height: 85px;
  width: 100%;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
`

const ResourceCard = ({ resource }) => {
  const isClickable = Boolean(resource.url || resource.file_url)

  const handleResourceClick = () => {
    window.open(resource.file_url ? resource.file_url : resource.url, '_blank')
  }

  return (
    <ResourceContainerCard onClick={isClickable && handleResourceClick}>
      <div style={{ height: '70px', position: 'relative' }}>
        <a>
          {resource.resource_type !== null && (
            <div
              style={{ position: 'absolute', width: '100%', height: '85px' }}
            >
              <div style={{ margin: '6% 42%' }}>
                {getViewResourceIcon(resource.resource_type)}
              </div>
            </div>
          )}
        </a>
        {resource.thumbnail_url === null ? (
          <ImagePlaceholder />
        ) : (
          <ResourceImage image={resource.thumbnail_url} />
        )}
      </div>
      <div style={{ padding: '25px' }}>
        <H5 style={{ marginBottom: '10px' }}>{resource.name}</H5>
        {resource.description !== null && (
          <MarkdownLabel value={resource.description} />
        )}
      </div>
    </ResourceContainerCard>
  )
}

ResourceCard.propTypes = {
  resource: PropTypes.object.isRequired
}

export default ResourceCard



// WEBPACK FOOTER //
// ./src/components/mycourses/Activities/ResourceCard.js